import { UserModel, PortfolioModel, WishlistModel, ArtistModel, AddressModel } from 'models';
import { JSONObject } from 'models/Api/types';
import { ItemActiveMarketData } from 'models/Item/types';
import { UserOrderInfo } from 'models/User/User';

export enum UserActionTypes {
  SET_USER = 'SET_USER',
  CLEAR_USER = 'CLEAR_USER',

  GET_USER_FOLLOWING_ARTISTS = 'GET_USER_FOLLOWING_ARTISTS',
  GET_USER_FOLLOWING_ARTISTS_SUCCESS = 'GET_USER_FOLLOWING_ARTISTS_SUCCESS',
  GET_USER_FOLLOWING_ARTISTS_FAILURE = 'GET_USER_FOLLOWING_ARTISTS_FAILURE',
  FOLLOW_ARTIST = 'FOLLOW_ARTIST',
  FOLLOW_ARTIST_SUCCESS = 'FOLLOW_ARTIST_SUCCESS',
  FOLLOW_ARTIST_FAILURE = 'FOLLOW_ARTIST_FAILURE',
  UNFOLLOW_ARTIST = 'UNFOLLOW_ARTIST',
  UNFOLLOW_ARTIST_SUCCESS = 'UNFOLLOW_ARTIST_SUCCESS',
  UNFOLLOW_ARTIST_FAILURE = 'UNFOLLOW_ARTIST_FAILURE',

  GET_USER_PORTFOLIO = 'GET_USER_PORTFOLIO',
  GET_USER_PORTFOLIO_SUCCESS = 'GET_USER_PORTFOLIO_SUCCESS',
  GET_USER_PORTFOLIO_FAILURE = 'GET_USER_PORTFOLIO_FAILURE',

  GET_USER_WISHLIST = 'GET_USER_WISHLIST',
  GET_USER_WISHLIST_SUCCESS = 'GET_USER_WISHLIST_SUCCESS',
  GET_USER_WISHLIST_FAILURE = 'GET_USER_WISHLIST_FAILURE',

  GET_USER_ACTIVE_MARKET = 'GET_USER_ACTIVE_MARKET',
  GET_USER_ACTIVE_MARKET_SUCCESS = 'GET_USER_ACTIVE_MARKET_SUCCESS',
  GET_USER_ACTIVE_MARKET_FAILURE = 'GET_USER_ACTIVE_MARKET_FAILURE',

  MIGRATE_USER_IMAGE = 'MIGRATE_USER_IMAGE',
  MIGRATE_USER_IMAGE_SUCCESS = 'MIGRATE_USER_IMAGE_SUCCESS',
  MIGRATE_USER_IMAGE_FAILURE = 'MIGRATE_USER_IMAGE_FAILURE',

  CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD',
  CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS',
  CHANGE_USER_PASSWORD_FAILURE = 'CHANGE_USER_PASSWORD_FAILURE',

  SEND_CONFIRMATION_EMAIL = 'SEND_CONFIRMATION_EMAIL',
  SEND_CONFIRMATION_EMAIL_SUCCESS = 'SEND_CONFIRMATION_EMAIL_SUCCESS',
  SEND_CONFIRMATION_EMAIL_FAILURE = 'SEND_CONFIRMATION_EMAIL_FAILURE',

  SEND_FORGOT_PASSWORD_EMAIL = 'SEND_FORGOT_PASSWORD_EMAIL',
  SEND_FORGOT_PASSWORD_EMAIL_SUCCESS = 'SEND_FORGOT_PASSWORD_EMAIL_SUCCESS',
  SEND_FORGOT_PASSWORD_EMAIL_FAILURE = 'SEND_FORGOT_PASSWORD_EMAIL_FAILURE',

  CONFIRM_EMAIL = 'CONFIRM_EMAIL',
  CONFIRM_EMAIL_SUCCESS = 'CONFIRM_EMAIL_SUCCESS',
  CONFIRM_EMAIL_FAILURE = 'CONFIRM_EMAIL_FAILURE',

  CHANGE_FORGOTTEN_PASSWORD = 'CHANGE_FORGOTTEN_PASSWORD',
  CHANGE_FORGOTTEN_PASSWORD_SUCCESS = 'CHANGE_FORGOTTEN_PASSWORD_SUCCESS',
  CHANGE_FORGOTTEN_PASSWORD_FAILURE = 'CHANGE_FORGOTTEN_PASSWORD_FAILURE',

  JOIN_USER_WAITLIST = 'JOIN_USER_WAITLIST',
  JOIN_USER_WAITLIST_SUCCESS = 'JOIN_USER_WAITLIST_SUCCESS',
  JOIN_USER_WAITLIST_FAILURE = 'JOIN_USER_WAITLIST_FAILURE',

  SEND_INBOUND_CONTACT_REQUEST = 'SEND_INBOUND_CONTACT_REQUEST',
  SEND_INBOUND_CONTACT_REQUEST_SUCCESS = 'SEND_INBOUND_CONTACT_REQUEST_SUCCESS',
  SEND_INBOUND_CONTACT_REQUEST_FAILURE = 'SEND_INBOUND_CONTACT_REQUEST_FAILURE',

  UPDATE_USER_DATA = 'UPDATE_USER_DATA',
  UPDATE_USER_DATA_SUCCESS = 'UPDATE_USER_DATA_SUCCESS',
  UPDATE_USER_DATA_FAILURE = 'UPDATE_USER_DATA_FAILURE',

  DELETE_ITEM_ASK = 'USER_DELETE_ITEM_ASK',
  DELETE_ITEM_ASK_SUCCESS = 'USER_DELETE_ITEM_ASK_SUCCESS',
  DELETE_ITEM_ASK_FAILURE = 'USER_DELETE_ITEM_ASK_FAILURE',

  DELETE_ITEM_BID = 'USER_DELETE_ITEM_BID',
  DELETE_ITEM_BID_SUCCESS = 'USER_DELETE_ITEM_BID_SUCCESS',
  DELETE_ITEM_BID_FAILURE = 'USER_DELETE_ITEM_BID_FAILURE',

  UPDATE_ITEM_ASK = 'USER_UPDATE_ITEM_ASK',
  UPDATE_ITEM_ASK_SUCCESS = 'USER_UPDATE_ITEM_ASK_SUCCESS',
  UPDATE_ITEM_ASK_FAILURE = 'USER_UPDATE_ITEM_ASK_FAILURE',

  UPDATE_ITEM_BID = 'USER_UPDATE_ITEM_BID',
  UPDATE_ITEM_BID_SUCCESS = 'USER_UPDATE_ITEM_BID_SUCCESS',
  UPDATE_ITEM_BID_FAILURE = 'USER_UPDATE_ITEM_BID_FAILURE',

  ACTIVATE_SELLING = 'USER_ACTIVATE_SELLING',
  ACTIVATE_SELLING_SUCCESS = 'USER_ACTIVATE_SELLING_SUCCESS',
  ACTIVATE_SELLING_FAILURE = 'USER_ACTIVATE_SELLING_FAILURE',

  GENERATE_SELLER_ONBOARDING_LINK = 'GENERATE_SELLER_ONBOARDING_LINK',
  GENERATE_SELLER_ONBOARDING_LINK_SUCCESS = 'GENERATE_SELLER_ONBOARDING_LINK_SUCCESS',
  GENERATE_SELLER_ONBOARDING_LINK_FAILURE = 'GENERATE_SELLER_ONBOARDING_LINK_FAILURE',

  GENERATE_SELLER_DASHBOARD_LINK = 'GENERATE_SELLER_DASHBOARD_LINK',
  GENERATE_SELLER_DASHBOARD_LINK_SUCCESS = 'GENERATE_SELLER_DASHBOARD_LINK_SUCCESS',
  GENERATE_SELLER_DASHBOARD_LINK_FAILURE = 'GENERATE_SELLER_DASHBOARD_LINK_FAILURE',

  GET_ORDERS = 'USER_GET_ORDERS',
  GET_ORDERS_SUCCESS = 'USER_GET_ORDERS_SUCCESS',
  GET_ORDERS_FAILURE = 'USER_GET_ORDERS_FAILURE',

  ADD_PRIMARY_ADDRESS = 'USER_ADD_PRIMARY_ADDRESS',
  ADD_PRIMARY_ADDRESS_SUCCESS = 'USER_ADD_PRIMARY_ADDRESS_SUCCESS',
  ADD_PRIMARY_ADDRESS_FAILURE = 'USER_ADD_PRIMARY_ADDRESS_FAILURE',
  ADD_SECONDARY_ADDRESS = 'USER_ADD_SECONDARY_ADDRESS',
  ADD_SECONDARY_ADDRESS_SUCCESS = 'USER_ADD_SECONDARY_ADDRESS_SUCCESS',
  ADD_SECONDARY_ADDRESS_FAILURE = 'USER_ADD_SECONDARY_ADDRESS_FAILURE',
  REMOVE_SECONDARY_ADDRESS = 'USER_REMOVE_SECONDARY_ADDRESS',
  REMOVE_SECONDARY_ADDRESS_SUCCESS = 'USER_REMOVE_SECONDARY_ADDRESS_SUCCESS',
  REMOVE_SECONDARY_ADDRESS_FAILURE = 'USER_REMOVE_SECONDARY_ADDRESS_FAILURE',

};

export interface UserActionPayload {
  user?: UserModel;
  id?: string;
  itemId?: string;
  itemBidId?: string;
  itemAskId?: string
  artistId?: string;
  email?: string;
  name?: string;
  message?: string;
  portfolio?: PortfolioModel;
  wishlist?: WishlistModel;
  artistList?: ArtistModel[];
  activeMarket?: ItemActiveMarketData;
  orders?: UserOrderInfo;
  imageUrl?: string;
  oldPassword?: string;
  newPassword?: string;
  token?: string;
  updatedData?: JSONObject;
  askData?: JSONObject;
  bidData?: JSONObject;
  onboardingLink?: string;
  dashboardLink?: string;
  address?: AddressModel;
};

export interface UserAction {
  type: UserActionTypes;
  payload?: UserActionPayload;
};

export interface UserStateLoading {
  user: boolean;
  portfolio: boolean;
  wishlist: boolean;
  activeMarket: boolean;
  orders: boolean
  activeMarketAction: boolean;
  followingArtists: boolean;
  wishlistAction: boolean;
  artistAction: boolean;
  imageAction: boolean;
  passwordAction: boolean;
  confirmationAction: boolean;
  mailAction: boolean;
  waitlistAction: boolean;
  updateAction: boolean;
  marketplaceAction: boolean;
  addressAction: boolean;
};


export interface UserState {
  user: UserModel;
  error: Error | undefined;
  loading: UserStateLoading;
  sellerOnboardingLink: string;
  sellerDashboardLink: string;
};
